import React, { useState, useEffect } from 'react';
import { Box, Button, Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, CircularProgress, Dialog } from '@mui/material';
import { FetchRoles } from '../../../../services/api';
import CreateRoleForm from './CreateRoleForm';

import usePermission from '../../../../hooks/usePermission';

const RolesList = () => {
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [openCreate, setOpenCreate] = useState(false);
    const token = localStorage.getItem('accessToken');
    const { can } = usePermission();

    useEffect(() => {
        loadRoles();
    }, []);

    const loadRoles = async () => {
        setLoading(true);
        const response = await FetchRoles(token);
        if (response?.data?.roles) {
            setRoles(response.data.roles);
        } else {
            // Check if response itself is the array or if it's encapsulated differently
            if (Array.isArray(response?.data)) {
                 setRoles(response.data);
            } else {
                 console.log('Roles response:', response);
                 setError('Failed to fetch roles');
            }
        }
        setLoading(false);
    };

    if (loading) return <CircularProgress />;
    if (error) return <Typography color="error">{error}</Typography>;

    return (
        <Box>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h5">Roles</Typography>
                {can('settings.roles.create') && (
                    <Button variant="contained" color="primary" onClick={() => setOpenCreate(true)}>Create Role</Button>
                )}
            </Box>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell>Organization</TableCell>
                            <TableCell>Category</TableCell>
                            <TableCell>Status</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {roles.map((role) => (
                            <TableRow key={role.id}>
                                <TableCell>{role.name}</TableCell>
                                <TableCell>{role.description}</TableCell>
                                <TableCell>{role.organization?.organizationName || role.organizationId || '-'}</TableCell>
                                <TableCell>{role.roleCategory}</TableCell>
                                <TableCell>{role.isActive ? 'Active' : 'Inactive'}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            
            <Dialog open={openCreate} onClose={() => setOpenCreate(false)} maxWidth="md" fullWidth>
                <CreateRoleForm onClose={() => setOpenCreate(false)} onSuccess={loadRoles} />
            </Dialog>
        </Box>
    );
};

export default RolesList;
